import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewLocationComp from "./Component/ViewLocationComp"


const ViewLocation =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewLocationComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewLocation